import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: false,
};

export const togglerSlice = createSlice({
  name: 'toggler',
  initialState,
  reducers: {
    showsidebar: (state) => {
      state.value = true;
    },
    hidesidebar: (state) => {
      state.value = false;
    },
  },
});

export const { showsidebar, hidesidebar } = togglerSlice.actions;
export const togglerReducer = togglerSlice.reducer;
export default togglerSlice.reducer;
